module.exports = __webpack_public_path__ + "fonts/DINPro-Black.041c39c3.ttf";